import type { ReactNode } from 'react';

import styles from './BeforeAfter.module.css';

import { Caret } from '../../icons';
import { AccessibleContent } from '../AccessibleContent';
import { Text } from '../Text';

export interface BeforeAfterProps {
  /** The "before" node. */
  before: ReactNode;
  /** The "after" node. */
  after: ReactNode;
  /** The text used for accessibility. */
  accessibleText: string;
}

/**
 * Display a strike-out value (the before node) and a normal value (the after
 * node).
 *
 * @see https://corgi-x.tfd.engineering/components/beforeafter
 */
export function BeforeAfter(props: BeforeAfterProps): JSX.Element {
  return (
    <AccessibleContent
      visualContent={
        <div className={styles.container}>
          <Text
            variant="heading-22"
            color="Charcoal2"
            className={styles.before}
            data-testid="before"
          >
            {props.before}
          </Text>
          <Caret aria-hidden className={styles.caretIcon} />
          <Text
            variant="heading-22"
            color="Charcoal3"
            data-testid="after"
            className={styles.after}
          >
            {props.after}
          </Text>
        </div>
      }
      accessibleText={props.accessibleText}
    />
  );
}
